import React from 'react';
import clsx from 'clsx';

import makeStyles from '@mui/styles/makeStyles';
import ButtonBase from '@mui/material/ButtonBase';

import useIconParrot from 'hooks/useIconParrot';

const useStyles = makeStyles((theme) => ({
  label: {
    width: '100%', // Ensure the correct width for iOS Safari
    display: 'inherit',
    alignItems: 'inherit',
    justifyContent: 'inherit',
    fontSize: 16,
    fontWeight: 500,
    fontFamily: 'Roboto',
    color: theme.palette.common.black,

    '&:hover': {
      color: '#262626',
      textDecoration: 'underline',
    },
  },

  startIcon: {
    display: 'inherit',
    marginRight: 16,
  },

  disabledLabel: {
    color: theme.palette.darkGrey[15],
  },
}));

function ButtonNavigationBack({ children, disabled = false, ...others }) {
  const classes = useStyles();

  const { IconBack } = useIconParrot({ icon: 'back' });

  return (
    <ButtonBase data-testid="goBackButton" disableRipple disableTouchRipple disabled={disabled} {...others}>
      <span
        className={clsx(classes.label, {
          [classes.disabledLabel]: disabled,
        })}
      >
        <span className={clsx(classes.startIcon)}>
          <IconBack />
        </span>
        <span className="label">{children}</span>
      </span>
    </ButtonBase>
  );
}

ButtonNavigationBack.propTypes = {
  ...ButtonBase.propTypes,
};

export default ButtonNavigationBack;
